// 결제 페이지에서 뒤로가기로 나올 때 보낸 "임시예약 점유 해제" 요청이 서버에서 끝나기를 기다리기 위한 보관소.
// 클라이언트 이동(SPA)에서는 이 모듈의 값이 페이지 간에 유지되므로, 이전 페이지가 시작한 해제 요청을
// 다음 페이지의 조회 요청이 기다릴 수 있다. (기다리지 않으면 해제 전 상태, 즉 '예약마감'을 받아와 새로고침 전까지 그대로 보인다)
let pendingRelease: Promise<unknown> | null = null;

export function trackHoldRelease(request: Promise<unknown>) {
  const tracked: Promise<unknown> = request
    .catch(() => undefined)
    .finally(() => {
      if (pendingRelease === tracked) pendingRelease = null;
    });
  pendingRelease = tracked;
}

/** 진행 중인 점유 해제 요청이 있으면 끝날 때까지(최대 maxMs) 기다린다. 없으면 즉시 반환. */
export async function waitForHoldRelease(maxMs = 3000) {
  if (!pendingRelease) return;
  await Promise.race([pendingRelease, new Promise((resolve) => setTimeout(resolve, maxMs))]);
}
